/* global google map */
'use strict';

const storeLocatorLazyload = require('./storeLocatorLazyload');

function createStoreMarkerIcon(store, markerIndex) {
    var markerDiv = document.createElement("div");

    markerDiv.className = store.jsFilters + ' ';
    markerDiv.className += 'store-locator__' + store.icon;

    if (store.icon !== 'icon') {
        markerDiv.textContent = Number(markerIndex) + 1;
    }

    return markerDiv;
}

function StoreMarkerOverlay(position, content, infoWindow, store, map) {
    this.position = position;
    this.content = content;
    this.id = store.id;
    this.infoWindow = infoWindow;
    this.map = map;
    this.div = null;
}

async function getStoreDetailsHtml(storeID) {
    var html = $('#store-' + storeID);
    if (html.hasClass('js-lazy-store')) {
        return storeLocatorLazyload.loadLazyStoreHtml(html);
    }
    return html.html();
}

StoreMarkerOverlay.prototype = new google.maps.OverlayView();
StoreMarkerOverlay.prototype.onAdd = function() {
    var self = this;
    this.div = document.createElement('div');
    this.div.className = 'custom-overlay';
    this.div.appendChild(this.content);

    this.div.addEventListener('click', async function() {
        var content = await getStoreDetailsHtml(self.id);
        self.infoWindow.setContent(content);
        self.infoWindow.setPosition(self.position);
        self.infoWindow.open(self.map);
    });

    this.getPanes().overlayImage.appendChild(this.div);
};
StoreMarkerOverlay.prototype.draw = function() {
    var projection = this.getProjection();
    var point = projection.fromLatLngToDivPixel(this.position);
    if (point && this.div) {
        this.div.style.left = point.x + 'px';
        this.div.style.top = point.y + 'px';
        this.div.style.position = 'absolute';
    }
};
StoreMarkerOverlay.prototype.onRemove = function() {
    if (this.div) {
        this.div.parentNode.removeChild(this.div);
        this.div = null;
    }
};

function addStoreMarkerOverlay(map, store, position, markerIndex, infoWindow) {
    var content = createStoreMarkerIcon(store, markerIndex);
    var overlay = new StoreMarkerOverlay(position, content, infoWindow, store, map);
    overlay.setMap(map);
    return overlay;
}

function addStoreMarkers(map, storeLocations, infoWindow) {
    $.each(storeLocations, function (markerIndex, store) {
        var position = new google.maps.LatLng(store.lat, store.lng);
        addStoreMarkerOverlay(map, store, position, markerIndex, infoWindow);
    });
}

function createGoogleMap($mapContainer) {
    const MAP_STYLE_SETTINGS = [
        {
            featureType: "poi.business",
            stylers: [{ visibility: "off" }]
        }
    ];
    const MAP_OPTIONS = {
        scrollwheel: false,
        zoom: 18,
        minZoom: 6,
        maxZoom: 18,
        mapId: 'default',
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false
    };

    const map = new google.maps.Map($mapContainer[0], MAP_OPTIONS);
    map.mapTypes.set('default', new google.maps.StyledMapType(MAP_STYLE_SETTINGS));
    return map;
}

/**
 * Draws a search radius circle and a marker for the current location on the map.
 * Optionally colors the circle based on the `showRadius` URL parameter.
 *
 * @param {Object} map - The Google Maps instance.
 * @param {number} latitude - Latitude of the center point.
 * @param {number} longitude - Longitude of the center point.
 * @param {Object} bounds - The map bounds to extend and fit.
 * @param {Array<Object>} storeLocations - Array of store location objects, each with latitude and longitude.
 */
function addCurrentLocation(map, latitude, longitude, bounds, storeLocations) {
    var center = { lat: latitude, lng: longitude };
    var position = new google.maps.LatLng(storeLocations[0].lat, storeLocations[0].lng);

    if (window.currentLocationMarker) {
        window.currentLocationMarker.setMap(null);
    }

    if (center.lat && center.lng) {
        window.currentLocationMarker = new google.maps.marker.AdvancedMarkerElement({
            position: center,
            map: map,
            title: "Current Location"
        });

        bounds.extend(position);
        map.fitBounds(bounds);
    }
}

function attachMapEventListeners(map) {
    map.addListener("idle", function() {
        $('body').trigger('update:filters');
    });
}

$(async function setupStoreLocatorMap() {
    var $mapContainer = $('.map-canvas');
    var latitude = parseFloat($('#lat').val());
    var longitude = parseFloat($('#long').val());
    var storeLocations = $mapContainer.data('locations');
    var infoWindow = new google.maps.InfoWindow();
    var bounds = new google.maps.LatLngBounds(new google.maps.LatLng(latitude, longitude));
    var map = createGoogleMap($mapContainer);

    window.map = map;

    addStoreMarkers(map, storeLocations, infoWindow);
    addCurrentLocation(map, latitude, longitude, bounds, storeLocations);
    attachMapEventListeners(map);
});

$(document).on('update:map', function (e, data) {
    if (data.stores && data.showMap) {
        var lat = data.lat;
        var lng = data.long;
        var storeLocations = data.stores;
        var center = new google.maps.LatLng(lat, lng);
        var bounds = new google.maps.LatLngBounds(center);

        map.setCenter(center);

        addCurrentLocation(map, lat, lng, bounds, storeLocations);
    }
});
